import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const adminToken = localStorage.getItem("furshala_admin_token");
  const userToken = localStorage.getItem("furshala_user_token");
  // Admin endpoints use the admin token; everything else uses the pet-parent user token if present.
  const isAdmin = url.startsWith("/admin") || url.includes("/admin/");
  const token = isAdmin ? adminToken : (userToken || adminToken);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return pathOrUrl;
};
